import { USER_TYPE, ADMIN_TYPE } from '../contants'

export default {
  install (Vue, opts) {
    Object.defineProperty(Vue.prototype, '$auth', {
      value: function (name) {
        return this.$store.state.permission[name] || false
      }
    })

    Object.defineProperty(Vue.prototype, '$isBeginner', {
      value: function () {
        return this.$store.state.loginUser.type === USER_TYPE.beginner
      }
    })

    Object.defineProperty(Vue.prototype, '$isIntermediate', {
      value: function () {
        return this.$store.state.loginUser.type === USER_TYPE.intermediate
      }
    })

    Object.defineProperty(Vue.prototype, '$isAdvanced', {
      value: function () {
        return this.$store.state.loginUser.type === USER_TYPE.advanced
      }
    })

    Object.defineProperty(Vue.prototype, '$isAdmin', {
      value: function (type) {
        return (
          (type || this.$store.state.loginUser.type) === USER_TYPE.super &&
          this.$store.state.loginUser.isAdmin !== 1
        )
      }
    })

    Object.defineProperty(Vue.prototype, '$isSuperAdmin', {
      value: function () {
        return (
          this.$store.state.loginUser.type === USER_TYPE.super &&
          this.$store.state.loginUser.isAdmin === ADMIN_TYPE.on
        )
      }
    })

    Object.defineProperty(Vue.prototype, '$USER_TYPE', {
      value: USER_TYPE
    })
  }
}
